import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getCifClientesActivos`, method: 'GET', body: null, token: token})
}
